import { styled } from '@linaria/react';

export const DiscountBadge = styled.span`
	position: absolute;
	left: 50%;
	top: -10px;
	width: max-content;
	padding: 4px 10px;
	font-weight: 700;
	font-size: 9.3px;
	z-index: 1;
	text-transform: uppercase;
	border-radius: 7px;
	background: var(--light-blue-bg);
	transition: opacity 0.2s, transform 0.2s;
	transform: translateX(-50%);
	&:empty {
		display: none;
	}
`;
